import { groupBy, sortBy } from 'lodash';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { isWarningWorkflow } from './isWarningWorkflow';

export const sortDownstreamWorkflowResults = (
  workflowResults: GraphQLTypes.DownstreamTaskCardFragment[],
) => {
  const workflowsGroupByStatus = groupBy(
    workflowResults,
    (result) => result?.downstreamWorkflow?.status,
  );

  const failedOrWarningWorkflows = sortBy(
    workflowsGroupByStatus[GraphQLTypes.CheckWorkflowStatus.FAILED],
    (result) => result.downstreamWorkflow?.baseVariant?.name,
  );

  const failedWorkflows = failedOrWarningWorkflows.filter(
    (result) =>
      !isWarningWorkflow(
        result.downstreamWorkflow,
        result.failsUpstreamWorkflow,
      ),
  );

  const warningWorkflows = failedOrWarningWorkflows.filter((result) =>
    isWarningWorkflow(result.downstreamWorkflow, result.failsUpstreamWorkflow),
  );

  const passedWorkflows = sortBy(
    workflowsGroupByStatus[GraphQLTypes.CheckWorkflowStatus.PASSED],
    (result) => result.downstreamWorkflow?.baseVariant?.name,
  );

  const pendingWorkflows = sortBy(
    workflowsGroupByStatus[GraphQLTypes.CheckWorkflowStatus.PENDING],
    (result) => result.downstreamWorkflow?.baseVariant?.name,
  );

  return [
    ...(failedWorkflows ?? []),
    ...(warningWorkflows ?? []),
    ...(passedWorkflows ?? []),
    ...(pendingWorkflows ?? []),
  ];
};
